import React, { Component } from 'react';
import GalleryImage from './GalleryImage/GalleryImage';
import {applicationModes} from '../constants';



let imageDescriptors = {
  default: {
    image1: {
      transformation: { dpr: 'auto', aspect_ratio: '330:210', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'sharpen:200' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected faces</li><li>Sharpen the image</li></ul>'
    },
    image2: {
      transformation: { dpr: 'auto', aspect_ratio: '356:140', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'sepia' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected faces</li><li>Apply a sepia effect</li></ul>'
    },
    image3: {
      transformation: { dpr: 'auto', aspect_ratio: '369:140', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'blue:100' },
      description: '<ul><li>Crop the image to a different aspect ratio, focusing on auto-detected faces</li><li>Increase the intensity of the blue channel</li></ul>'
    },
    image4: {
      transformation: { dpr: 'auto', aspect_ratio: '280:350', width: 'auto', crop: 'thumb', gravity: 'auto' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    },
    image5: {
      transformation: [{ aspect_ratio: '240:350', width: 'auto', crop: 'fill', gravity: 'auto' }, { overlay: 'cloudinary_icon.png', gravity: 'center', width: 0.4, flags: 'relative', color: 'white', effect: 'colorize', opacity: 50, dpr: 'auto' }],
      description: '<p>Create a portrait image and add a watermark.</p><ul><li>Overlay an existing image already uploaded to Cloudinary, in this case the Cloudinary logo</li><li>Set the overlay dimensions to 40% of the image size</li><li>Make it white and set its opacity to 50%</li>'
    }
  },
  ga: {
    image1: {
      transformation: { dpr: 'auto', aspect_ratio: '330:210', width: 'auto', crop: 'fill', gravity: 'faces' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected areas of interest</li></ul>'
    },
    image2: {
      transformation: { dpr: 'auto', aspect_ratio: '356:140', width: 'auto', crop: 'thumb', gravity: 'faces' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    },
    image3: {
      transformation: { dpr: 'auto', aspect_ratio: '369:140', width: 'auto', crop: 'fill', gravity: 'faces' },
      description: '<ul><li>Crop the image to a different aspect ratio, focusing on auto-detected areas of interest</li></ul>'
    },
    image4: {
      transformation: { dpr: 'auto', aspect_ratio: '280:350', width: 'auto', crop: 'thumb', gravity: 'auto' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    },
    image5: {
      transformation: [{ aspect_ratio: '240:350', width: 'auto', crop: 'fill', gravity: 'auto' }],
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected areas of interest</li></ul>'
    }
  }
};

export default class GalleryMedium extends Component {
  render() {
    let desc = imageDescriptors[this.props.applicationMode] || imageDescriptors[applicationModes.DEFAULT];

    return (
      <div style={{ position: 'relative' }} className="gallery-medium">
        <div style={{ position: 'relative' }}>
          <GalleryImage {...this.props} format="jpg" transformation={desc.image1.transformation} style={{ width: '38%', top: 0, bottom: 0, left: '0%' }}  >
            <div dangerouslySetInnerHTML={{ __html: desc.image1.description }} />
          </GalleryImage>
          <GalleryImage {...this.props} className="primary" format="jpg" transformation={desc.image2.transformation} style={{ width: '62%', height: '25.63vw', left: '38%' }} >
            <div dangerouslySetInnerHTML={{ __html: desc.image2.description }} />
          </GalleryImage>
        </div>
        <div style={{ position: 'relative' }}>
          <GalleryImage {...this.props} className="primary" format="jpg" transformation={desc.image3.transformation} style={{ width: '63.888%', left: 0, height: '25.63vw' }} >
            <div dangerouslySetInnerHTML={{ __html: desc.image3.description }} />
          </GalleryImage>
          <GalleryImage {...this.props} format="jpg" transformation={desc.image4.transformation} style={{ width: '19.4444%', top: 0, bottom: 0, left: '63.888%' }} >
            <div dangerouslySetInnerHTML={{ __html: desc.image4.description }} />
          </GalleryImage>
          <GalleryImage {...this.props} format="jpg" transformation={desc.image5.transformation} style={{ width: '16.666%', top: 0, bottom: 0, left: '83.333%' }} >
            <div dangerouslySetInnerHTML={{ __html: desc.image5.description }} />
          </GalleryImage>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/GalleryMedium.js
 **/